import {
  ADD_DIGITALLY_RECEIVED,
  ComponentsActionTypes,
  DELETE_ALL_COMPONENTS,
  DELETE_ALL_SECTIONS,
  DELETE_SECTION,
  DELETE_COMPONENT_SECTION,
  SET_COMPONENT_SECTION,
  DELETE_SERIES_SUBMISSION_WINDOW,
  SET_IS_LOADING,
  GET_COMPONENTS,
  SET_COMPONENT,
  SET_COMPONENTS,
  SET_FETCHED_COMPONENT,
  SET_ERROR,
  SET_IS_REPORT_BEING_GENERATED,
  DELETE_COMPONENT_SECTIONS,
} from './types';

import { Component, ComponentsData } from '../../types/Components';
import { LocalSection } from '../../service/components/types';

export const setIsLoading = (value: boolean): ComponentsActionTypes => ({
  type: SET_IS_LOADING,
  payload: { value },
});

export const getComponents = (): ComponentsActionTypes => ({
  type: GET_COMPONENTS,
});

export const setComponents = (components: ComponentsData): ComponentsActionTypes => ({
  type: SET_COMPONENTS,
  payload: { components },
});

export const setComponent = (componentId: Component['_id'], component: Component): ComponentsActionTypes => ({
  type: SET_COMPONENT,
  payload: { componentId, component },
});

export const setComponentSection = (componentId: Component['_id'], component: Component): ComponentsActionTypes => ({
  type: SET_COMPONENT_SECTION,
  payload: { componentId, component },
});

export const setFetchedComponent = (component?: Component): ComponentsActionTypes => ({
  type: SET_FETCHED_COMPONENT,
  payload: { component },
});

export const addDigitallyReceived = (
  componentId: Component['_id'],
  sectionData: LocalSection,
): ComponentsActionTypes => ({
  type: ADD_DIGITALLY_RECEIVED,
  payload: { componentId, sectionData },
});

export const deleteSection = (componentId: Component['_id'], id: number): ComponentsActionTypes => ({
  type: DELETE_SECTION,
  payload: { componentId, id },
});

export const deleteComponentSection = (componentId: Component['_id'], id: number): ComponentsActionTypes => ({
  type: DELETE_COMPONENT_SECTION,
  payload: { componentId, id },
});

export const deleteComponentSections = (componentId: Component['_id']): ComponentsActionTypes => ({
  type: DELETE_COMPONENT_SECTIONS,
  payload: { componentId },
});

export const deleteSeriesSubmissionWindow = (
  componentId: Component['_id'],
  id: number,
  field: 'submissionWindow' | 'marksSubmissionWindow',
): ComponentsActionTypes => ({
  type: DELETE_SERIES_SUBMISSION_WINDOW,
  payload: { componentId, id, field },
});

export const deleteAllSections = (componentId: Component['_id']): ComponentsActionTypes => ({
  type: DELETE_ALL_SECTIONS,
  payload: { componentId },
});

export const deleteAllComponents = (): ComponentsActionTypes => ({
  type: DELETE_ALL_COMPONENTS,
});

export const setIsReportBeingGenerated = (isReportBeingGenerated: boolean): ComponentsActionTypes => ({
  type: SET_IS_REPORT_BEING_GENERATED,
  payload: { isReportBeingGenerated },
});

export const setError = (): ComponentsActionTypes => ({
  type: SET_ERROR,
});

export default {
  deleteSeriesSubmissionWindow,
  deleteSection,
  deleteComponentSection,
  deleteComponentSections,
  setComponents,
  setIsLoading,
  getComponents,
  setError,
  setComponent,
  setComponentSection,
  setFetchedComponent,
  addDigitallyReceived,
  deleteAllSections,
  deleteAllComponents,
  setIsReportBeingGenerated,
};
